import classNames from "classnames"
import { ExpandLess, ExpandMore, SquaredMinus, SquaredPlus } from "components/LEGACY/styled-components/Icons"
import { parseProductGroupImageURL, parseProductGroupName } from "components/orderPage/functions/products"
import IconButton from "components/utils/IconButton"
import { useCategoryProductGroups } from "hooks/firestore/advanced/useCategoryProductGroups"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { useCategories } from "hooks/firestore/simple/useCategories"
import Image from "next/image"
import { useState } from "react"
import ProductGroup from "types/firestore/productGroup"

interface ProductGroupSelectorProps {
  selected: boolean
  pg: WithRef<ProductGroup>
  onClick: (v: string) => void
}

function ProductGroupSelector({ selected, pg, onClick }: ProductGroupSelectorProps) {
  const imgSrc = parseProductGroupImageURL(pg)?.url
  const name = parseProductGroupName(pg)
  return (
    <>
      <style jsx>{`
        .productSelectorButton {
          outline: none;
          padding: 0.25rem;
          /* width: 100%; */
          display: grid;
          background: transparent;
          border: 1px solid var(--dark);
          margin: 0.25rem;
          border-radius: 5px;
          align-items: center;
          grid-template-columns: auto 1fr auto;
          cursor: pointer;
        }
        .image {
          height: 35px;
          width: 35px;
          object-fit: cover;
          background: var(--light);
          border-radius: 5px;
          overflow: hidden;
        }
        .name {
          margin: 0 0.5rem;
          font-size: 1rem;
          text-align: left;
        }
      `}</style>
      <button className="productSelectorButton" onClick={() => onClick(pg._ref.id)}>
        <div className="image">
          {imgSrc && <Image className="image" width="35" height="35" src={imgSrc} alt="Artikelbild" />}
        </div>
        <p className="name">{name}</p>
        <IconButton icon={selected ? <SquaredMinus darkgrey size="16" /> : <SquaredPlus success size="16" />} />
      </button>
    </>
  )
}

interface ProductSelectorProps {
  productIds: Array<string>
  setProductIds: (productIds: Array<string>) => void
  disabled: boolean
}
export default function ProductSelector({ productIds, setProductIds, disabled }: ProductSelectorProps) {
  const categories = useCategories()?.filter(category => (category.productGroups ?? [])?.length > 0)

  const [foldOpenCategory, setFoldOpenCategory] = useState<string | undefined>(undefined) // id of the open one
  const productGroups = useCategoryProductGroups(foldOpenCategory)

  const toggleProduct = (productId: string) => {
    if (disabled) return
    if (productIds.includes(productId)) {
      return setProductIds(productIds.filter(pId => pId !== productId))
    }
    setProductIds([...productIds, productId])
  }

  return (
    <>
      <style jsx>{`
        .selectorContainer {
          border: 1px solid var(--dark);
          padding: 0.5rem;
          border-radius: 15px;
          max-height: 250px;
          overflow: scroll;
        }
        .productSelectorContainer {
          display: flex;
          flex-direction: column;
        }
        .productSelectorContainer.disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
        .heading {
          color: currentcolor;
        }
        .accordeonItemContainer {
          border: 1px solid var(--dark);
          margin: 0.25rem;
          border-radius: 5px;
        }
        .accordeonItemHeader {
          display: flex;
          width: 100%;
          outline: none;
          border: none;
          background: transparent;
          padding: 0.5rem;
        }
        .name {
          margin: 0 0.5rem;
          font-size: 1rem;
          text-align: left;
        }
        .accordeonItemBody {
          /* padding: 0.5rem; */
          display: flex;
          flex-direction: column;
        }
      `}</style>
      <div className={classNames("productSelectorContainer", { disabled })}>
        <h6 className="heading">Alle verfügbaren Produkte:</h6>
        <div className="selectorContainer">
          {categories?.map(category => {
            return (
              <div className="accordeonItemContainer" key={category._ref.id}>
                <button
                  className="accordeonItemHeader"
                  onClick={() => {
                    if (category._ref.id === foldOpenCategory) {
                      return setFoldOpenCategory(undefined)
                    }
                    setFoldOpenCategory(category._ref.id)
                  }}
                >
                  <IconButton
                    icon={
                      category._ref.id === foldOpenCategory ? (
                        <ExpandLess grey size="16" />
                      ) : (
                        <ExpandMore grey size="16" />
                      )
                    }
                  />

                  <p className="name">{category.name}</p>
                </button>
                {category._ref.id === foldOpenCategory && (
                  <div className="accordeonItemBody">
                    {productGroups?.length === 0 && (
                      <p style={{ padding: "0.5rem", margin: 0 }}>
                        In dieser Kategorie sind keine eingeschalteten Produkte verfügbar
                      </p>
                    )}
                    {productGroups?.map(pg => {
                      return (
                        <ProductGroupSelector
                          pg={pg}
                          key={pg._ref.id}
                          onClick={() => toggleProduct(pg._ref.id)}
                          selected={productIds.includes(pg._ref.id)}
                        />
                      )
                    })}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
